import "./DesktopDashboard.css";
import { useState } from "react";
import { appsApi } from "../../../api";

const steps = [
  { id: 1, label: "Step 1", title: "App Name" },
  { id: 2, label: "Step 2", title: "Monetization Tool" },
  { id: 3, label: "Step 3", title: "Currency and Exchange Rates" },
  // { id: 4, label: "Step 4", title: "Wall Customization" },
  { id: 4, label: "Step 4", title: "Postbacks" },
];

export default function AddAppWizard({ onClose = () => {}, initialApp = null }) {
  const [activeStep, setActiveStep] = useState(1);
  const [form, setForm] = useState({
    appName: initialApp?.name || "",
    appUrl: initialApp?.appUrl || "",
    monetizationTool: initialApp?.monetizationTool || "Offerwall SDK - Android",
    currencyName: initialApp?.currencyName || "",
    exchangeRate: initialApp?.exchangeRate || "",
    roundPayout: !!initialApp?.roundPayout,
    optOutS2s: !!initialApp?.optOutS2s,
    optOutEmail: !!initialApp?.optOutEmail,
    negativePostback: !!initialApp?.negativePostback,
    resendCount: initialApp?.resendCount?.toString?.() || "5",
    postbackMode: initialApp?.postbackMode || "minimal",
    postbackUrl: initialApp?.postbackUrl || "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const monetizationOptions = [
    // "Offerwall - Desktop / Mobile Web",
    // "API / Offers Gallery",
    "Offerwall SDK - Android"
    // "Offerwall SDK - Unity",
  ];

  const goNext = () =>
    setActiveStep((s) => Math.min(Number(s || 0) + 1, steps.length));
  const goPrev = () =>
    setActiveStep((s) => Math.max(Number(s || 1) - 1, 1));

  const extractPackageName = (value = "") => {
    const raw = String(value || "").trim();
    if (!raw) return "";
    try {
      const url = new URL(raw);
      const playId = url.searchParams.get("id");
      if (playId) return playId.trim();
      const pathParts = url.pathname.split("/").filter(Boolean);
      const lastPart = pathParts[pathParts.length - 1];
      if (lastPart && lastPart.includes(".")) return lastPart.trim();
    } catch (_) {
      const match = raw.match(/id=([A-Za-z0-9._-]+)/);
      if (match?.[1]) return match[1].trim();
      const last = raw.split("/").filter(Boolean).pop();
      if (last && last.includes(".")) return last.trim();
    }
    return raw;
  };

  async function handleFinish() {
    try {
      setSaving(true);
      setError("");
      const existingBundleId = initialApp?.bundleId || initialApp?.id;
      const extractedPackage = extractPackageName(form.appUrl);
      const payload = {
        name: form.appName || "Untitled App",
        bundleId: (existingBundleId || extractedPackage || form.appName || `app-${Date.now()}`).replace(/[^a-zA-Z0-9._-]/g, ""),
        platform: "web",
        appUrl: form.appUrl,
        monetizationTool: form.monetizationTool,
        currencyName: form.currencyName,
        exchangeRate: Number(form.exchangeRate) || undefined,
        roundPayout: form.roundPayout,
        optOutS2s: form.optOutS2s,
        optOutEmail: form.optOutEmail,
        negativePostback: form.negativePostback,
        resendCount: Number(form.resendCount) || 1,
        postbackMode: form.postbackMode,
        postbackUrl: form.postbackUrl
      };
      await appsApi.createApp(payload);
      onClose();
    } catch (err) {
      setError(err?.data?.statusText || err?.message || "Failed to save app.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="table-card add-app-card">
      <div className="table-head">
        <h3>Create New</h3>
        <div className="how-to">How to?</div>
      </div>

      <div className="wizard-steps">
        {steps.map((step, idx) => (
          <div key={step.id} className="wizard-step">
          <div className={`wizard-dot ${activeStep === step.id ? "is-active" : ""} ${activeStep > step.id ? "is-complete" : ""}`}>
            {step.id}
          </div>
            {idx < steps.length - 1 && <div className="wizard-line" />}
            <div className="wizard-labels">
              <div className="wizard-label">{step.label}</div>
              <div className="wizard-title">{step.title}</div>
            </div>
          </div>
        ))}
      </div>

      {activeStep === 1 && (
        <div className="wizard-section">
          <h4>App Name</h4>
          <p className="text-muted">Input the Name of the App and the URL of your website or app.</p>

          <div className="wizard-field">
            <label>App Name: *</label>
            <input
              type="text"
              placeholder="Name of your App/Game/Website."
              value={form.appName}
              onChange={(e) => setForm((f) => ({ ...f, appName: e.target.value }))}
            />
            <small>This identifies your App all throughout our system</small>
          </div>

          <div className="wizard-field">
            <label>App URL: *</label>
            <input
              type="text"
              placeholder="The URL of your website or app."
              value={form.appUrl}
              onChange={(e) => setForm((f) => ({ ...f, appUrl: e.target.value }))}
            />
            <small>The URL of your App Placement</small>
          </div>
        </div>
      )}

      {activeStep === 2 && (
        <div className="wizard-section">
          <h4>Monetization Tool</h4>
          <p className="text-muted">
            Select the Monetization Tool from the options presented. Choosing the right monetization tool
            is necessary in order to maximize your traffic potential.
          </p>

          <div className="wizard-options">
            {/* <div className="wizard-option">
              <strong>Offerwall - Desktop / Mobile Web</strong>
              <div className="text-muted">Browser Web Offerwall: monetize your desktop / mobile traffic.</div>
            </div> */}
            {/* <div className="wizard-option">
              <strong>API / Offers Gallery</strong>
              <div className="text-muted">Server to server integration / Choose specific offers to promote.</div>
            </div> */}
            <div className="wizard-option">
              <strong>Offerwall SDK - Android</strong>
              <div className="text-muted">In-App Android Offerwall: monetize your mobile traffic.</div>
            </div>
            {/* <div className="wizard-option">
              <strong>Offerwall SDK - Unity</strong>
              <div className="text-muted">In-App Unity Offerwall: monetize your mobile traffic.</div>
            </div> */}
          </div>

          <div className="wizard-field">
            <label>Monetization Tool: *</label>
            <select
              value={form.monetizationTool}
              onChange={(e) => setForm((f) => ({ ...f, monetizationTool: e.target.value }))}
            >
              {monetizationOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
            <small>Select Monetization Tool.</small>
          </div>
        </div>
      )}

      {activeStep === 3 && (
        <div className="wizard-section">
          <h4>Currency and Exchange Rates</h4>
          <p className="text-muted">Your App's Currency and the equivalent Exchange Rates.</p>

          <div className="wizard-field">
            <label>The name of your currency: *</label>
            <input
              type="text"
              placeholder="Currency"
              value={form.currencyName}
              onChange={(e) => setForm((f) => ({ ...f, currencyName: e.target.value }))}
            />
            <small>What is the name of your currency?</small>
          </div>

          <div className="wizard-field">
            <label>Exchange Rate: *</label>
            <input
              type="text"
              placeholder="Value of your virtual currency per 1 USD."
              value={form.exchangeRate}
              onChange={(e) => setForm((f) => ({ ...f, exchangeRate: e.target.value }))}
            />
            <small>
              How many (currency) will be equivalent to 1$ in revenue. For example: if you insert 100 then for every 1$ you'll earn, the user will receive 100 (currency).
            </small>
          </div>

          <div className="wizard-field checkbox">
            <label>
              <input
                type="checkbox"
                checked={form.roundPayout}
                onChange={(e) => setForm((f) => ({ ...f, roundPayout: e.target.checked }))}
              />
              {" "}
              Round off VC payouts?
            </label>
            <small>Tick this box to round off virtual currency payouts.</small>
          </div>

          <div className="currency-calculator">
            <div className="calc-head">Currency Calculator</div>
            <table className="calc-table">
              <thead>
                <tr>
                  <th>Sample Payout</th>
                  <th>Currency Equivalent</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {["0.3", "1.7", "2.2"].map((p) => {
                  const payout = Number(p);
                  const rate = Number(form.exchangeRate) || 0;
                  const eq = Math.round(payout * rate * 100) / 100;
                  return (
                    <tr key={p}>
                      <td>${p}</td>
                      <td>{eq}</td>
                      <td>
                        If an Offer Payout is {p}, user will receive {eq} ({form.currencyName || "currency"}).
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* {activeStep === 4 && (
        <div className="wizard-section">
          <h4>Wall Customization</h4>
          <p className="text-muted">Customize your wall appearance (placeholder content).</p>
          <div className="placeholder-box">
            <p>Theme color, header logo, layout options can be configured here. (Dummy step)</p>
          </div>
        </div>
      )} */}

      {activeStep === 4 && (
        <div className="wizard-section">
          <h4>Postback Information</h4>
          <p className="text-muted">Define your s2s postback settings. Enter your Postback URL here.</p>

          {/* <div className="wizard-field checkbox">
            <label>
              <input
                type="checkbox"
                checked={form.optOutS2s}
                onChange={(e) => setForm((f) => ({ ...f, optOutS2s: e.target.checked }))}
              />{" "}
              Opt-out from receiving s2s postbacks?
            </label>
          </div>

          <div className="wizard-field checkbox">
            <label>
              <input
                type="checkbox"
                checked={form.optOutEmail}
                onChange={(e) => setForm((f) => ({ ...f, optOutEmail: e.target.checked }))}
              />{" "}
              Opt-out from receiving postback email notifications?
            </label>
          </div>

          <div className="wizard-field checkbox">
            <label>
              <input
                type="checkbox"
                checked={form.negativePostback}
                onChange={(e) => setForm((f) => ({ ...f, negativePostback: e.target.checked }))}
              />{" "}
              Send Negative Postback in case of Reversals?
            </label>
          </div> */}

          <div className="wizard-field">
            <label>Number of times to re-send Postback: *</label>
            <input
              type="number"
              min="1"
              max="5"
              value={form.resendCount}
              onChange={(e) => setForm((f) => ({ ...f, resendCount: e.target.value }))}
            />
            <small>No. of times to send the same postback in case of failures (minimum of 1, maximum of 5).</small>
          </div>

          <div className="wizard-field radio-group">
            <label>Postback URL: *</label>
            <div className="radio-row">
              <label>
                <input
                  type="radio"
                  name="postbackMode"
                  checked={form.postbackMode === "minimal"}
                  onChange={() => setForm((f) => ({ ...f, postbackMode: "minimal" }))}
                />{" "}
                Minimal Parameter Postback
              </label>
              <label>
                <input
                  type="radio"
                  name="postbackMode"
                  checked={form.postbackMode === "custom"}
                  onChange={() => setForm((f) => ({ ...f, postbackMode: "custom" }))}
                />{" "}
                Custom Parameter Postback
              </label>
            </div>
            <div className="text-muted small">
              Postback data added after the end of your postback URL such as:
              <br />
              http://www.Your-Site.com/pb/?OID=123&user_id=JohnSmith&Amount=10
            </div>
          </div>

          <div className="wizard-field">
            <input
              type="text"
              placeholder="Postback URL *"
              value={form.postbackUrl}
              onChange={(e) => setForm((f) => ({ ...f, postbackUrl: e.target.value }))}
            />
          </div>
        </div>
      )}

      <div className="wizard-actions">
        <button type="button" className="pill-btn grey" onClick={goPrev} disabled={activeStep === 1}>Previous</button>
        <button type="button" className="pill-btn grey" onClick={onClose}>Save as Draft</button>
        {activeStep === steps.length ? (
          <button type="button" className="pill-btn lime" onClick={handleFinish} disabled={saving}>
            {saving ? "Saving..." : initialApp ? "Update" : "Finish"}
          </button>
        ) : (
          <button type="button" className="pill-btn teal" onClick={goNext}>Next</button>
        )}
      </div>
      {error && <div className="wizard-error">{error}</div>}
    </section>
  );
}
